<template>
  <div>
    <Maintenance v-if="showMaintenance"></Maintenance>
    <router-view :key="version" v-else></router-view>
  </div>
</template>

<script>
import configLanguage from '@/config/configLanguage.json'
import Maintenance from '@/components/Maintenance.vue';
import moment from 'moment-timezone';

export default {
  data(){
    return{
      version : process.env.VUE_APP_NOCACHE_VERSION,
      showMaintenance : false,
      is_maintenance : process.env.VUE_APP_MAINTENANCE,
      start_maintenance : process.env.VUE_APP_START_MAINTENANCE,
      end_maintenance : process.env.VUE_APP_END_MAINTENANCE,
      
      languages : configLanguage[process.env.VUE_APP_ENVIRONMENT]?configLanguage[process.env.VUE_APP_ENVIRONMENT]:configLanguage['default']
    }
  },
  components:{
    Maintenance
  },
  mounted(){
    const language = localStorage.getItem('lang');
    const lang = language?language:'en-EN';

    const now = moment()
    
    const start = moment.tz(this.start_maintenance, 'YYYY-MM-DD HH:mm:ss', 'Asia/Jakarta')
    const end = moment.tz(this.end_maintenance, 'YYYY-MM-DD HH:mm:ss', 'Asia/Jakarta');
    
    if(this.is_maintenance==1 && now.isBetween(start, end, null, '[]')){
      document.body.classList.add('maintenance-mode');
      this.showMaintenance = true;
    }

    if(typeof this.languages[lang]!=="undefined"){
      this.$i18n.locale = lang; 
    }
    else{
      this.$i18n.locale = 'en-EN';
    }

    localStorage.setItem('lang',this.$i18n.locale);
    localStorage.setItem('lang-key',this.$i18n.locale);
  }
}

</script>
